/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-03 10:46:48
 */

import axios from "axios";
const queryString = require("query-string");

const { slotHours, showHourlySlots } =
  window["app-config"].applicationProperties;

export class DataService {
  URL = window["app-config"].URL;
  defaultLang = window["app-config"].defaultLang.split("_")[0];
  centralServerCommunication =
    window["app-config"].applicationProperties.centralServerCommunication;
  timeoutInterval = window["app-config"].applicationProperties.requestTimeout;
  regionId = window["app-config"].regionId;

  queryStringBranchCode = queryString.parse(window.location.search);
  branchCode = this.queryStringBranchCode.branchCode;

  queryStringlang = queryString.parse(window.location.search);
  lang =
    this.queryStringlang.lang === undefined
      ? this.defaultLang
      : this.queryStringlang.lang;

  /* GET REQUEST */
  getDeviceDetails = async () => {
    let url = `${this.URL.apiUrl}PhoneCustomInfo`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.get(this.URL.apiUrl + "PhoneCustomInfo");
      return response;
    }
  };

  getCategoriesByBranchId = async (branchId) => {
    let url = `${this.URL.apiUrl}Categories/${branchId}|${
      this.lang === "es" ? "Sp" : this.lang
    }`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  getAllBranches = async () => {
    let url = `${this.URL.apiUrl}GetBranchList/2|${
      this.lang === "es" ? "Sp" : this.lang
    }|${this.regionId}`;
    if (
      this.centralServerCommunication === false &&
      this.branchCode === undefined
    ) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else if (this.branchCode === undefined) {
      let response = axios.get(url, { timeout: this.timeoutInterval });
      return response;
    }
  };

  getSingleBranchDetails = async () => {
    let url = `${this.URL.apiUrl}GetSingleBranchDetails/2|${
      this.lang === "es" ? "Sp" : this.lang
    }|branch_code=${this.branchCode}`;

    if (
      this.centralServerCommunication === false &&
      this.branchCode !== undefined
    ) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else if (this.branchCode !== undefined) {
      let response = axios.get(url);
      return response;
    }
  };

  cancelAppointment = async (
    AppointmentNumber,
    categoryId,
    BranchId,
    Email
  ) => {
    let url = `${
      this.URL.apiUrl
    }CancelAppointmentTicket/${AppointmentNumber}|${categoryId}|${BranchId}|${Email}|${
      this.lang === "es" ? "Sp" : this.lang
    }`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.get(url);
      console.log(
        "APPT NO: ",
        AppointmentNumber,
        " Category: ",
        categoryId,
        " Branch: ",
        BranchId,
        " Email: ",
        Email
      );
      return response;
    }
  };

  issueTicket = async (
    branchId,
    categoryId,
    priority,
    email,
    deviceType,
    language,
    Payload1,
    Payload2,
    Payload3,
    Payload4,
    Payload7
  ) => {
    // email = "demo@wavetec.com";
    let url = `${this.URL.apiUrl}issueTicket/${branchId}|${categoryId}|${priority}|${email}|${deviceType}|-|-|${language}|-|${Payload1}|${Payload2}|${Payload3}|${Payload4}|-|${language}|${Payload7}`;
    console.log("ISSUE TICKET URL", url);
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );

      return response.data;
    } else {
      let response = axios.get(url);

      console.log(branchId, categoryId, priority, email, deviceType);
      return response;
    }
  };

  issueTicketQR = async (
    branchId,
    categoryId,
    prefix,
    priority,
    payload1,
    payload2,
    payload3,
    payload4,
    payload5,
    language,
    payload7,
    payload8,
    payload9,
    payload10
  ) => {
    let url = `${this.URL.QRticketUrl}IssueTicketFromWebTicketing?BranchId=${branchId}&SQN=${categoryId}&prefix=${prefix}&Payload1=${payload1}&Payload2=${payload2}&Payload3=${payload3}&Payload4=${payload4}&Payload5=${payload5}&Payload6=${language}&Payload7=${payload7}&Payload8=${payload8}&Payload9=${payload9}&Payload10=${payload10}&priority=${priority}`;
    console.log("ISSUE QR TICKET URL", url);
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );

      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  cancelQrTicket = async (branchId, branchCode, ticketId) => {
    let url = `${this.URL.QRticketUrl}CancelTicketFromWebTicketing?BranchId=${branchId}&BranchCode=${branchCode}&TicketId=${ticketId}&CancelReason=Cancel`;

    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      console.log("CANCEL QR TICKET URL", url);
      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  issueTicketSpectra = (postObject) => {
    let url = "";
    if (this.centralServerCommunication === false) {
      let response = axios.post(url, postObject);
      return response;
    }
  };

  cancelTicket = async (
    email,
    ticketId,
    branchId,
    language,
    ticketNumber,
    SQN,
    phoneNumber
  ) => {
    let url = `${this.URL.apiUrl}cancelTicket/${email}|${ticketId}|${branchId}|${language}|${ticketNumber}|${SQN}|${phoneNumber}`;
    console.log("CANCEL TICKET URL: ", url);
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  markAppointmentUsedAfterTicketIssue = async (
    appointmentNumber,
    emailAddress,
    ticketNumber
  ) => {
    let url = `${this.URL.apiUrl}TicketIssuedForAppointment/${appointmentNumber}|${emailAddress}|${ticketNumber}`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  verifyAppointmentInfo = async (
    email,
    phoneNumber,
    appointmentNumber,
    branchIp
  ) => {
    // let url = `${this.URL.apiUrl}VerifyAppointmentInfo/||||${appointmentNumber}||${branchIp}`;
    let url = `${this.URL.apiUrl}VerifyAppointmentInfo_Json/||${email}|${phoneNumber}|${appointmentNumber}||${branchIp}|`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: null,
        },
        { timeout: this.timeoutInterval }
      );
      console.log("VERIFY APPOINTMENT URL", url);
      return response.data;
    } else {
      let response = axios.get(url);
      return response;
    }
  };

  /* POST REQUEST */

  getDateTimeSlots = async (
    BranchID,
    CategoryID,
    AppointmentDate,
    AppointmentAheadDays
  ) => {
    let url = `${this.URL.apiUrl}GetAllDaysSlotsOfBranch`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            BranchID: BranchID,
            CategoryID: CategoryID,
            AppointmentDate: AppointmentDate,
            AppointmentAHeadDays: AppointmentAheadDays,
            SlotHours: slotHours,
            ShowHourlySlots: showHourlySlots,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(this.URL.apiUrl + "GetAllDaysSlotsOfBranch", {
        BranchID: BranchID,
        CategoryID: CategoryID,
        AppointmentDate: AppointmentDate,
        AppointmentAHeadDays: AppointmentAheadDays,
        SlotHours: slotHours,
        ShowHourlySlots: showHourlySlots,
      });
      return response;
    }
  };

  issueAppointment = async (
    CategoryID,
    BranchID,
    BranchTitle,
    BranchAddress,
    BranchContactNo,
    SlotID,
    DeviceType,
    AppointmentDate,
    UserID,
    Flag,
    IsReschedule,
    Payloads,
    Lang,
    SlotTime
  ) => {
    let url = `${this.URL.apiUrl}IssueAppointmentTicket`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            categoryid: CategoryID,
            branchid: BranchID,
            branchTitle: BranchTitle,
            branchAddress: BranchAddress,
            branchPhoneNumber: BranchContactNo,
            slotid: SlotID,
            deviceType: DeviceType,
            appointmentDate: AppointmentDate,
            userId: UserID,
            flag: Flag,
            isReschedule: IsReschedule,
            payloads: Payloads,
            lang: Lang,
            slotTime: SlotTime,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(this.URL.apiUrl + "IssueAppointmentTicket", {
        categoryid: CategoryID,
        branchid: BranchID,
        branchTitle: BranchTitle,
        branchAddress: BranchAddress,
        branchPhoneNumber: BranchContactNo,
        slotid: SlotID,
        deviceType: DeviceType,
        appointmentDate: AppointmentDate,
        userId: UserID,
        flag: Flag,
        isReschedule: IsReschedule,
        payloads: Payloads,
        lang: Lang,
        slotTime: SlotTime,
      });
      return response;
    }
  };

  rescheduleAppointment = async (
    PrevAppointmentNumber,
    PreviousApptCategoryId,
    CategoryID,
    BranchID,
    BranchTitle,
    BranchAddress,
    BranchContactNo,
    SlotID,
    DeviceType,
    AppointmentDate,
    UserID,
    Flag,
    IsReschedule,
    Payloads,
    Lang,
    SlotTime
  ) => {
    let url = `${this.URL.apiUrl}RescheduleAppointmentTicket`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            prevAppointmentNumber: PrevAppointmentNumber,
            previousApptCategoryId: PreviousApptCategoryId,
            categoryid: CategoryID,
            branchid: BranchID,
            branchTitle: BranchTitle,
            branchAddress: BranchAddress,
            branchPhoneNumber: BranchContactNo,
            slotid: SlotID,
            deviceType: DeviceType,
            appointmentDate: AppointmentDate,
            userId: UserID,
            flag: Flag,
            isReschedule: IsReschedule,
            payloads: Payloads,
            lang: Lang,
            slotTime: SlotTime,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(
        this.URL.apiUrl + "RescheduleAppointmentTicket",
        {
          prevAppointmentNumber: PrevAppointmentNumber,
          previousApptCategoryId: PreviousApptCategoryId,
          categoryid: CategoryID,
          branchid: BranchID,
          branchTitle: BranchTitle,
          branchAddress: BranchAddress,
          branchPhoneNumber: BranchContactNo,
          slotid: SlotID,
          deviceType: DeviceType,
          appointmentDate: AppointmentDate,
          userId: UserID,
          flag: Flag,
          isReschedule: IsReschedule,
          payloads: Payloads,
          lang: Lang,
          slotTime: SlotTime,
        }
      );
      return response;
    }
  };

  getTicketStatus = async (branchId, ticketId, ticketNumber, categoryId) => {
    let url = `${this.URL.apiUrl}GetTicketStatus`;
    let isLobbyLeader =
      window["app-config"].applicationProperties.isLobbyLeader;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            branch_id: branchId,
            ticket_id: ticketId,
            ticket_number: ticketNumber,
            category_id: categoryId,
            is_lobby_leader: isLobbyLeader,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(url, {
        branch_id: branchId,
        ticket_id: ticketId,
        ticket_number: ticketNumber,
        category_id: categoryId,
        is_lobby_leader: isLobbyLeader,
      });

      return response;
    }
  };

  getAppointmentInfo = async (appointmentNumber, email, phoneNumber) => {
    let url = `${this.URL.apiUrl}GetAppointmentInfo`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            appointment_number: appointmentNumber,
            email: email,
            cell_number: phoneNumber,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(this.URL.apiUrl + "GetAppointmentInfo", {
        appointment_number: appointmentNumber,
        email: email,
        cell_number: phoneNumber,
      });
      return response;
    }
  };

  getEstimatedWaitTime = async (branchId, Sqn) => {
    let url = `${this.URL.apiUrl}GetEstWaitTime`;
    if (this.centralServerCommunication === false) {
      let response = await axios.post(
        this.URL.messagingServerUrl,
        {
          payload: url,
          centralServerIp: this.URL.centralServerIp,
          body: {
            BranchId: branchId,
            SQN: Sqn,
          },
        },
        { timeout: this.timeoutInterval }
      );
      return response.data;
    } else {
      let response = axios.post(url, {
        BranchId: branchId,
        SQN: Sqn,
      });
      return response;
    }
  };
}
